import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import Header from './Header';
import FileUpload from './FileUpload';
import FileList from './FileList';
import StorageStats from './StorageStats';

function Dashboard() {
  const { user } = useAuth();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleFileUpload = (newFiles) => {
    setUploadedFiles(prev => [...prev, ...newFiles]);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleFileDelete = (fileId) => {
    setUploadedFiles(prev => prev.filter(f => f.id !== fileId));
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">
                Welcome back, {user.name}!
              </h1>
              <p className="text-gray-600">
                Upload and manage your files in your dedicated S3 folder: 
                <span className="font-mono bg-gray-100 px-2 py-1 rounded ml-2">{user.s3Folder}</span>
              </p>
            </div>
            {user.role === 'client' && (
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="#/profile"
                className="flex items-center space-x-2 bg-white text-blue-600 px-4 py-2 rounded-lg border border-blue-200 hover:bg-blue-50 transition-all"
              >
                <span>My Profile</span>
              </motion.a>
            )}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-8">
            <FileUpload onUpload={handleFileUpload} />
            <FileList 
              files={uploadedFiles} 
              onDelete={handleFileDelete} 
              refreshTrigger={refreshTrigger} 
            />
          </div>
          <div>
            <StorageStats 
              files={uploadedFiles} 
              refreshTrigger={refreshTrigger} 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;